export default "/images/vendor/flag-icon-css/flags/4x3/yt.svg?5c77b04743aada260f6b0daaa7c08793";